import type { ColDef } from 'ag-grid-enterprise';
import { getReferenceCellRenderer } from '../CellRenderers/cellRenderers';
import type {
  ReferenceInventoryColumn,
  ReferenceInventoryRow,
  RequestedReferenceColumn,
} from './types';

export type ReferenceInventoryColDef = ColDef<ReferenceInventoryRow> & {
  context: RequestedReferenceColumn;
};

const toColumnDef = (
  column: ReferenceInventoryColumn
): ReferenceInventoryColDef => {
  const { key, label, type, dataType, isVisible } = column;
  return {
    colId: key,
    field: key,
    headerName: label,
    hide: !isVisible,
    sortable: false,
    filter: false,
    cellRenderer: getReferenceCellRenderer(column),
    context: { key, label, type, dataType },
  };
};

export const getReferenceInventoryColumnDefs = (
  columns: ReferenceInventoryColumn[]
): ReferenceInventoryColDef[] => columns.map(toColumnDef);
